import { Periods } from '../../services';
import { createRestSlices, applyReducers } from './rest';

const {
    initialState, resetReducer,
    getReducer, listReducer, updateReducer, duplicateReducer,
    startCreateReducer, createReducer, deleteReducer,
    resetAction, getAction, listAction, updateAction, duplicateAction,
    startCreateAction, createAction, deleteAction
} = createRestSlices(Periods);

/* Export reducer */
export default (state = initialState, action) => {
    return applyReducers(state, action, [
        resetReducer,
        getReducer, listReducer, updateReducer, duplicateReducer,
        startCreateReducer, createReducer, deleteReducer
    ]);
}

/* Export CRUD actions */
export const resetPeriods      = resetAction;
export const startCreatePeriod = startCreateAction;
export const createPeriod      = createAction;
export const loadPeriod        = getAction;
export const loadPeriods       = listAction;
export const updatePeriod      = updateAction;
export const deletePeriod      = deleteAction;
export const duplicatePeriod   = duplicateAction;
